import apiClient from '../../shared/services/apiClient'

// 组件版本 + 热更新。错误统一由调用方用 errMsg() 显示后端 msg(关掉全局 toast,避免重复/文案丢失)
const BASE = '/api/admin/node'
const cfg = { skipGlobalErrorToast: true }

export const COMPONENTS = [
  { value: 'yeap-agent', label: 'Agent' },
  { value: 'cdn-edge', label: 'CDN 边缘' },
  { value: 'coredns', label: 'DNS' },
  { value: 'yeapmail', label: '邮件' },
  { value: 'host-manager', label: '容器管理' },
  { value: 'kvm-agent', label: 'EVM Agent' },
]

export const componentLabel = (c) => COMPONENTS.find((x) => x.value === c)?.label || c

export const errMsg = (e, fallback = '操作失败') =>
  e?.response?.data?.msg || e?.response?.data?.message || e?.message || fallback

const componentService = {
  list: () => apiClient.get(`${BASE}/components`, cfg).then((r) => r.data),
  scan: () => apiClient.post(`${BASE}/components/scan`, {}, cfg).then((r) => r.data),
  setLatest: (releaseId) => apiClient.post(`${BASE}/components/${releaseId}/latest`, {}, cfg).then((r) => r.data),
  setNotes: (releaseId, notes) => apiClient.post(`${BASE}/components/${releaseId}/notes`, { notes }, cfg).then((r) => r.data),

  // 单节点更新:无 version = 最新
  updateNode: (nodeId, payload) => apiClient.post(`${BASE}/nodes/${nodeId}/update`, payload, cfg).then((r) => r.data),

  // 批量更新
  createBatch: (payload) => apiClient.post(`${BASE}/updates/batch`, payload, cfg).then((r) => r.data),
  getBatch: (batchId) => apiClient.get(`${BASE}/updates`, { ...cfg, params: { batch_id: batchId } }).then((r) => r.data),
  listBatches: () => apiClient.get(`${BASE}/updates`, cfg).then((r) => r.data),
  resumeBatch: (batchId, retryFailed = false) =>
    apiClient.post(`${BASE}/updates/${batchId}/resume`, { retry_failed: retryFailed }, cfg).then((r) => r.data),
  cancelBatch: (batchId) => apiClient.post(`${BASE}/updates/${batchId}/cancel`, {}, cfg).then((r) => r.data),

  // 节点列表(批量弹窗选节点用,取全量)
  listAllNodes: () => apiClient.get(`${BASE}/nodes`, { ...cfg, params: { page_size: 1000 } }).then((r) => r.data),
}

export default componentService
